import React, { createContext, useContext, useState } from "react";

const T = {
  ru: {
    install: {
      title: "Установить Angiolini", subtitle: "На главный экран телефона",
      action: "Установить", later: "Позже", waiting: "Открываем…",
      iosShare: "В Safari нажмите «Поделиться».",
      iosOpenSafari: "Откройте эту страницу в Safari и нажмите «Поделиться».",
      iosAdd: "Выберите «На экран Домой», затем «Добавить».",
      error: "Установка сейчас недоступна. В меню браузера выберите «Установить приложение» или «На главный экран».",
    },
    nav: { home: "Главная", catalog: "Каталог", card: "Карта", tryon: "Примерка", news: "Новости", profile: "Профиль" },
    auth: {
      welcome: "Добро пожаловать",
      enterPhone: "Введите номер телефона для входа в VIP клуб Angiolini",
      getCode: "Получить код",
      sending: "Отправка...",
      demoCode: "Демо-код (SMS)",
      otpTitle: "Код подтверждения",
      sentTo: "Отправлен на",
      confirm: "Подтвердить",
      checking: "Проверка...",
      changePhone: "Изменить номер",
      createProfile: "Создать профиль",
      welcome2: "Добро пожаловать в мир Angiolini",
      yourName: "Ваше имя *",
      yourCity: "Ваш город",
      joinClub: "Вступить в клуб",
      creating: "Создание...",
      agree: "Продолжая, вы соглашаетесь с условиями использования VIP клуба Angiolini",
      enterName: "Введите ваше имя",
      registerError: "Ошибка регистрации.",
      wrongCode: "Неверный код.",
      tryAgain: "Ошибка. Попробуйте снова.",
      welcomeBonusTitle: "10 000 ₸ на счёт",
      welcomeBonusSub: "Бонусом за регистрацию в приложении",
      consentPrefix: "Я даю согласие на обработку моих",
      consentPersonalData: "персональных данных",
      consentMiddle: "и принимаю",
      consentLoyalty: "условия программы лояльности",
      consentRequired: "Подтвердите согласие на обработку персональных данных",
      contactsLink: "Контакты бутика и юридические сведения",
      smsSent: "SMS отправлено • проверьте сообщения",
      otpForNumber: "Номер:",
      otpSmsAccepted: "Запрос на отправку кода принят SMS-сервисом. Проверьте обычные SMS на телефоне.",
      otpWhatsappAccepted: "Запрос на отправку кода принят WhatsApp. Дождитесь сообщения.",
      otpSmsFallback: "WhatsApp-код сейчас недоступен — используем резервную отправку по SMS.",
      otpSendFailed: "Отправка кода не подтверждена. Попробуйте позже или свяжитесь с бутиком.",
      otpManualEntry: "Ввести код от менеджера",
      otpManualNotice: "Введите код, который вам выдал менеджер. Это не подтверждение отправки SMS.",
      smsUndeliverableLine1: "SMS не может быть доставлено на этот номер.",
      smsUndeliverableLine2: "Проверьте правильность номера или свяжитесь с менеджером по",
      smsUndeliverableSuffix: "— он выдаст код вручную.",
      smsInvalidPhone: "Неверный формат номера. Проверьте номер и попробуйте снова.",
      smsTransient: "Не удалось отправить SMS. Попробуйте ещё раз через минуту или свяжитесь с поддержкой.",
      regBonusPrefix: "После регистрации",
      regBonusAmount: "+10 000 ₸ бонусов",
      regBonusSuffix: "на ваш счёт",
      birthDatePlaceholder: "Дата рождения (дд.мм.гггг)",
      referralPlaceholder: "Реферальный код (необязательно)",
    },
    legal: {
      title: "Правовая информация",
      subtitle: "ТОО «Italy Retail» · Бутик Angiolini",
      back: "Назад",
      tabs: { contacts: "Контакты", privacy: "Политика конфиденциальности", terms: "Условия лояльности" },
      contacts: {
        boutique: "Бутик",
        address: "Адрес",
        addressValue: "г. Алматы, ул. Аль-Фараби 5/2,\nТЦ «Jurek Tau», -1 этаж",
        phone: "Телефон",
        whatsapp: "WhatsApp",
        email: "Email",
        hours: "Часы работы",
        hoursValue: "Ежедневно 10:00 — 22:00",
        legalHeader: "Юридические реквизиты",
        legalDetails: "ТОО «Italy Retail»\nБИН 220540021868\nРеспублика Казахстан, г. Алматы\nул. Аль-Фараби 5/2, ТЦ «Jurek Tau», -1 этаж",
      },
      actions: {
        readTitle: "Пожалуйста, ознакомьтесь с документом",
        confirm: "Я ознакомлен(а) и подтверждаю",
        reject: "Не подтверждаю",
      },
    },
    dashboard: {
      welcome: "ДОБРО ПОЖАЛОВАТЬ",
      bonuses: "БОНУСОВ",
      purchasesShort: "Покупок",
      appointment: "Записаться на примерку",
      selectStyle: "Подобрать образ",
      catalog: "Смотреть каталог",
      newArrivals: "Новинки из Италии",
      newsPromos: "Новости и акции",
      all: "Все",
      details: "Подробнее",
      whatsapp: "Написать стилисту в WhatsApp",
      vipExclusive: "VIP EXCLUSIVE",
    },
    bonus: {
      title: "VIP Карта",
      bonuses: "БОНУСОВ",
      progress: "Прогресс до",
      max: "MAX",
      maxReached: "Высший статус достигнут",
      toStatus: "₸ до статуса",
      history: "История бонусов",
      levels: "Уровни VIP",
      empty: "История пуста",
      from: "от",
    },
    catalog: {
      title: "Каталог",
      search: "Поиск товаров...",
      all: "Все",
      notFound: "Товары не найдены",
    },
    product: {
      size: "Размер",
      description: "Описание",
      bonusInfo: "При покупке вы получите",
      bonusInfoSuffix: "бонусов (5% от суммы)",
      fitting: "Примерка",
      askWhatsapp: "Узнать в WhatsApp",
      notFound: "Товар не найден",
      goBack: "Вернуться",
      loading: "Загрузка...",
    },
    news: {
      title: "Новости и акции",
      all: "Все",
      promos: "Акции",
      collections: "Коллекции",
      vip: "VIP",
      empty: "Нет новостей",
      read: "Читать",
      hide: "Скрыть",
      promotion: "Акция",
      collection: "Коллекция",
      newsItem: "Новость",
      vipExclusive: "VIP Exclusive",
    },
    appointment: {
      title: "Запись на примерку",
      subtitle: "Наш менеджер свяжется с вами для подтверждения записи",
      name: "Ваше имя *",
      phone: "Номер телефона *",
      city: "Ваш город",
      date: "Желаемая дата (дд.мм.гг)",
      category: "Категория товара",
      comment: "Комментарий (необязательно)",
      submit: "Записаться на примерку",
      submitting: "Отправка...",
      success: "Заявка принята",
      thankYou: "Спасибо! Менеджер Angiolini свяжется с вами в ближайшее время для подтверждения записи.",
      whatsapp: "Написать в WhatsApp",
      home: "На главную",
      errorRequired: "Заполните обязательные поля",
      errorSend: "Ошибка отправки",
    },
    profile: {
      bonuses: "Бонусов",
      purchasesLabel: "Покупок ₸",
      city: "ГОРОД",
      bonusCard: "Бонусная карта и история",
      catalog: "Каталог товаров",
      news: "Новости и акции",
      appointment: "Записаться на примерку",
      recent: "Последние операции",
      logout: "Выйти из аккаунта",
      language: "Язык",
      pushOn: "Push-уведомления включены",
      pushOff: "Включить push-уведомления",
      pushBusy: "Запрос разрешения...",
      pushBlocked: "Уведомления заблокированы в браузере",
      pushUnsupported: "Уведомления не поддерживаются",
      pushTitle: "Получать уведомления",
      pushHintOn: "Новые коллекции, акции, VIP-предложения и новости бутика",
      pushHintOff: "Включите, чтобы узнавать о новых коллекциях и событиях бутика",
      pushHintBlocked: "Уведомления выключены в настройках устройства",
      pushHintBridge: "Приложению не удалось подключиться к системе уведомлений — откройте диагностику ниже",
      pushHintUnsupported: "Это устройство не поддерживает push-уведомления",
      pushOpenSettings: "Открыть настройки",
    },
    common: {
      loading: "Загрузка...",
      back: "Назад",
      more: "Подробнее",
      all: "Все",
      notFound: "Не найдено",
      cancel: "Отмена",
      save: "Сохранить",
    },
  },

  kz: {
    install: {
      title: "Angiolini орнату", subtitle: "Телефонның басты экранына",
      action: "Орнату", later: "Кейінірек", waiting: "Ашылуда…",
      iosShare: "Safari браузерінде «Бөлісу» түймесін басыңыз.",
      iosOpenSafari: "Осы бетті Safari-де ашып, «Бөлісу» түймесін басыңыз.",
      iosAdd: "«Басты экранға» тармағын, содан кейін «Қосу» түймесін таңдаңыз.",
      error: "Қазір орнату мүмкін емес. Браузер мәзірінен «Қолданбаны орнату» немесе «Басты экранға» тармағын таңдаңыз.",
    },
    nav: { home: "Басты", catalog: "Каталог", card: "Карта", tryon: "Өлшеу", news: "Жаңалықтар", profile: "Профиль" },
    auth: {
      welcome: "Қош келдіңіз",
      enterPhone: "Angiolini VIP клубына кіру үшін телефон нөмірін енгізіңіз",
      getCode: "Код алу",
      sending: "Жіберілуде...",
      demoCode: "Демо-код (SMS)",
      otpTitle: "Растау коды",
      sentTo: "Жіберілді",
      confirm: "Растау",
      checking: "Тексерілуде...",
      changePhone: "Нөмірді өзгерту",
      createProfile: "Профиль жасау",
      welcome2: "Angiolini әлеміне қош келдіңіз",
      yourName: "Атыңыз *",
      yourCity: "Қалаңыз",
      joinClub: "Клубқа кіру",
      creating: "Жасалуда...",
      agree: "Жалғастыра отырып, Angiolini VIP клубының шарттарына келісесіз",
      enterName: "Атыңызды енгізіңіз",
      registerError: "Тіркеу қатесі.",
      wrongCode: "Қате код.",
      tryAgain: "Қате. Қайта көріңіз.",
      welcomeBonusTitle: "Есепке 10 000 ₸",
      welcomeBonusSub: "Қосымшада тіркелгені үшін бонус ретінде",
      consentPrefix: "Менің",
      consentPersonalData: "жеке деректерімді",
      consentMiddle: "өңдеуге келісім беремін және",
      consentLoyalty: "адалдық бағдарламасының шарттарын",
      consentRequired: "Жеке деректерді өңдеуге келісім беруіңізді растаңыз",
      contactsLink: "Бутик байланыстары және заңды мәліметтер",
      smsSent: "SMS жіберілді • хабарламаларды тексеріңіз",
      otpForNumber: "Нөмір:",
      otpSmsAccepted: "Код жіберу сұрауын SMS қызметі қабылдады. Телефондағы кәдімгі SMS хабарламаларын тексеріңіз.",
      otpWhatsappAccepted: "Код жіберу сұрауын WhatsApp қабылдады. Хабарламаны күтіңіз.",
      otpSmsFallback: "WhatsApp коды қазір қолжетімсіз — резервтік SMS жіберуді қолданамыз.",
      otpSendFailed: "Код жіберілгені расталмады. Кейінірек қайталаңыз немесе бутикке хабарласыңыз.",
      otpManualEntry: "Менеджер берген кодты енгізу",
      otpManualNotice: "Менеджер берген кодты енгізіңіз. Бұл SMS жіберілгенін растамайды.",
      smsUndeliverableLine1: "SMS осы нөмірге жеткізілмеді.",
      smsUndeliverableLine2: "Нөмірдің дұрыстығын тексеріңіз немесе менеджерге хабарласыңыз:",
      smsUndeliverableSuffix: "— ол сізге кодты қолмен береді.",
      smsInvalidPhone: "Нөмір форматы дұрыс емес. Нөмірді тексеріп, қайта көріңіз.",
      smsTransient: "SMS жіберу мүмкін болмады. Бір минуттан кейін қайталаңыз немесе қолдау қызметіне хабарласыңыз.",
      regBonusPrefix: "Тіркелгеннен кейін",
      regBonusAmount: "+10 000 ₸ бонус",
      regBonusSuffix: "сіздің есебіңізге",
      birthDatePlaceholder: "Туған күні (кк.аа.жжжж)",
      referralPlaceholder: "Рефералдық код (міндетті емес)",
    },
    legal: {
      title: "Заңды ақпарат",
      subtitle: "«Italy Retail» ЖШС · Angiolini бутигі",
      back: "Артқа",
      tabs: { contacts: "Байланыстар", privacy: "Құпиялылық саясаты", terms: "Адалдық шарттары" },
      contacts: {
        boutique: "Бутик",
        address: "Мекенжай",
        addressValue: "Алматы қ., Әл-Фараби к-сі 5/2,\n«Jurek Tau» СО, -1 қабат",
        phone: "Телефон",
        whatsapp: "WhatsApp",
        email: "Email",
        hours: "Жұмыс уақыты",
        hoursValue: "Күн сайын 10:00 — 22:00",
        legalHeader: "Заңды деректемелер",
        legalDetails: "«Italy Retail» ЖШС\nБСН 220540021868\nҚазақстан Республикасы, Алматы қ.\nӘл-Фараби к-сі 5/2, «Jurek Tau» СО, -1 қабат",
      },
      actions: {
        readTitle: "Құжатпен танысыңыз",
        confirm: "Мен таныстым және растаймын",
        reject: "Растамаймын",
      },
    },
    dashboard: {
      welcome: "ҚОШ КЕЛДІҢІЗ",
      bonuses: "БОНУС",
      purchasesShort: "Сатып алулар",
      appointment: "Өлшеуге жазылу",
      selectStyle: "Имидж таңдау",
      catalog: "Каталогты қарау",
      newArrivals: "Италиядан жаңалықтар",
      newsPromos: "Жаңалықтар мен акциялар",
      all: "Барлығы",
      details: "Толығырақ",
      whatsapp: "WhatsApp-та стилистке жазу",
      vipExclusive: "VIP EXCLUSIVE",
    },
    bonus: {
      title: "VIP Карта",
      bonuses: "БОНУС",
      progress: "Прогресс",
      max: "MAX",
      maxReached: "Жоғарғы статусқа жеттіңіз",
      toStatus: "₸ статусына дейін",
      history: "Бонус тарихы",
      levels: "VIP деңгейлері",
      empty: "Тарих жоқ",
      from: "бастап",
    },
    catalog: {
      title: "Каталог",
      search: "Тауарларды іздеу...",
      all: "Барлығы",
      notFound: "Тауарлар табылмады",
    },
    product: {
      size: "Өлшем",
      description: "Сипаттамасы",
      bonusInfo: "Сатып алғанда сіз аласыз",
      bonusInfoSuffix: "бонус (соманың 5%)",
      fitting: "Өлшеу",
      askWhatsapp: "WhatsApp-та сұрау",
      notFound: "Тауар табылмады",
      goBack: "Қайту",
      loading: "Жүктелуде...",
    },
    news: {
      title: "Жаңалықтар мен акциялар",
      all: "Барлығы",
      promos: "Акциялар",
      collections: "Коллекциялар",
      vip: "VIP",
      empty: "Жаңалық жоқ",
      read: "Оқу",
      hide: "Жасыру",
      promotion: "Акция",
      collection: "Коллекция",
      newsItem: "Жаңалық",
      vipExclusive: "VIP Exclusive",
    },
    appointment: {
      title: "Өлшеуге жазылу",
      subtitle: "Менеджеріміз растау үшін сізбен байланысады",
      name: "Атыңыз *",
      phone: "Телефон нөмірі *",
      city: "Қалаңыз",
      date: "Қажетті күн (кк.аа.жж)",
      category: "Тауар санаты",
      comment: "Пікір (міндетті емес)",
      submit: "Өлшеуге жазылу",
      submitting: "Жіберілуде...",
      success: "Өтінім қабылданды",
      thankYou: "Рахмет! Angiolini менеджері жақын арада сізбен байланысады.",
      whatsapp: "WhatsApp-та жазу",
      home: "Басты бетке",
      errorRequired: "Міндетті өрістерді толтырыңыз",
      errorSend: "Жіберу қатесі",
    },
    profile: {
      bonuses: "Бонус",
      purchasesLabel: "Сатып алулар ₸",
      city: "ҚАЛА",
      bonusCard: "Бонус картасы мен тарихы",
      catalog: "Тауарлар каталогы",
      news: "Жаңалықтар мен акциялар",
      appointment: "Өлшеуге жазылу",
      recent: "Соңғы операциялар",
      logout: "Шығу",
      language: "Тіл",
      pushOn: "Push-хабарландырулар қосылған",
      pushOff: "Push-хабарландыруларды қосу",
      pushBusy: "Рұқсат сұралуда...",
      pushBlocked: "Хабарландырулар браузерде бұғатталған",
      pushUnsupported: "Хабарландырулар қолдау таппайды",
      pushTitle: "Хабарландыруларды алу",
      pushHintOn: "Жаңа коллекциялар, акциялар, VIP-ұсыныстар және бутик жаңалықтары",
      pushHintOff: "Жаңа коллекциялар туралы білу үшін қосыңыз",
      pushHintBlocked: "Хабарландырулар құрылғы параметрлерінде өшірілген",
      pushHintBridge: "Қосымша хабарландыру жүйесіне қосыла алмады — төмендегі диагностиканы ашыңыз",
      pushHintUnsupported: "Бұл құрылғы push-хабарландыруларды қолдамайды",
      pushOpenSettings: "Параметрлерді ашу",
    },
    common: {
      loading: "Жүктелуде...",
      back: "Артқа",
      more: "Толығырақ",
      all: "Барлығы",
      notFound: "Табылмады",
      cancel: "Бас тарту",
      save: "Сақтау",
    },
  },

  en: {
    install: {
      title: "Install Angiolini", subtitle: "Add to your phone’s home screen",
      action: "Install", later: "Later", waiting: "Opening…",
      iosShare: "In Safari, tap Share.",
      iosOpenSafari: "Open this page in Safari, then tap Share.",
      iosAdd: "Choose Add to Home Screen, then tap Add.",
      error: "Installation is unavailable right now. Use Install app or Add to Home Screen in your browser menu.",
    },
    nav: { home: "Home", catalog: "Catalog", card: "Card", tryon: "Try-On", news: "News", profile: "Profile" },
    auth: {
      welcome: "Welcome",
      enterPhone: "Enter your phone number to access Angiolini VIP Club",
      getCode: "Get Code",
      sending: "Sending...",
      demoCode: "Demo Code (SMS)",
      otpTitle: "Verification Code",
      sentTo: "Sent to",
      confirm: "Confirm",
      checking: "Checking...",
      changePhone: "Change number",
      createProfile: "Create Profile",
      welcome2: "Welcome to the world of Angiolini",
      yourName: "Your name *",
      yourCity: "Your city",
      joinClub: "Join the Club",
      creating: "Creating...",
      agree: "By continuing, you agree to the Angiolini VIP Club terms of service",
      enterName: "Enter your name",
      registerError: "Registration error.",
      wrongCode: "Wrong code.",
      tryAgain: "Error. Please try again.",
      welcomeBonusTitle: "10,000 ₸ credited",
      welcomeBonusSub: "As a welcome bonus for signing up in the app",
      consentPrefix: "I consent to the processing of my",
      consentPersonalData: "personal data",
      consentMiddle: "and accept the",
      consentLoyalty: "loyalty program terms",
      consentRequired: "Please confirm consent to the processing of personal data",
      contactsLink: "Boutique contacts & legal information",
      smsSent: "SMS sent • check your messages",
      otpForNumber: "Phone:",
      otpSmsAccepted: "The SMS service accepted the code request. Check the regular SMS messages on your phone.",
      otpWhatsappAccepted: "WhatsApp accepted the code request. Please wait for the message.",
      otpSmsFallback: "WhatsApp codes are currently unavailable — using the SMS fallback.",
      otpSendFailed: "Sending the code was not confirmed. Please try later or contact the boutique.",
      otpManualEntry: "Enter a code from a manager",
      otpManualNotice: "Enter the code your manager provided. This does not confirm an SMS was sent.",
      smsUndeliverableLine1: "SMS cannot be delivered to this number.",
      smsUndeliverableLine2: "Verify the number is correct or contact the manager via",
      smsUndeliverableSuffix: "— they will provide the code manually.",
      smsInvalidPhone: "Invalid phone number format. Check the number and try again.",
      smsTransient: "Failed to send SMS. Please try again in a minute or contact support.",
      regBonusPrefix: "After registration you get",
      regBonusAmount: "+10,000 ₸ bonus",
      regBonusSuffix: "to your account",
      birthDatePlaceholder: "Date of birth (dd.mm.yyyy)",
      referralPlaceholder: "Referral code (optional)",
    },
    legal: {
      title: "Legal Information",
      subtitle: "Italy Retail LLP · Angiolini Boutique",
      back: "Back",
      tabs: { contacts: "Contacts", privacy: "Privacy Policy", terms: "Loyalty Terms" },
      contacts: {
        boutique: "Boutique",
        address: "Address",
        addressValue: "Almaty, 5/2 Al-Farabi St.,\nJurek Tau Mall, -1 floor",
        phone: "Phone",
        whatsapp: "WhatsApp",
        email: "Email",
        hours: "Hours",
        hoursValue: "Daily 10:00 — 22:00",
        legalHeader: "Legal Details",
        legalDetails: "Italy Retail LLP\nBIN 220540021868\nRepublic of Kazakhstan, Almaty\n5/2 Al-Farabi St., Jurek Tau Mall, -1 floor",
      },
      actions: {
        readTitle: "Please review this document",
        confirm: "I have read and confirm",
        reject: "Don't confirm",
      },
    },
    dashboard: {
      welcome: "WELCOME",
      bonuses: "BONUSES",
      purchasesShort: "Purchases",
      appointment: "Book a Fitting",
      selectStyle: "Style Consultation",
      catalog: "View Catalog",
      newArrivals: "New from Italy",
      newsPromos: "News & Promotions",
      all: "All",
      details: "Details",
      whatsapp: "Message Our Stylist on WhatsApp",
      vipExclusive: "VIP EXCLUSIVE",
    },
    bonus: {
      title: "VIP Card",
      bonuses: "BONUSES",
      progress: "Progress to",
      max: "MAX",
      maxReached: "Highest status achieved",
      toStatus: "₸ to status",
      history: "Bonus History",
      levels: "VIP Levels",
      empty: "No history",
      from: "from",
    },
    catalog: {
      title: "Catalog",
      search: "Search products...",
      all: "All",
      notFound: "No products found",
    },
    product: {
      size: "Size",
      description: "Description",
      bonusInfo: "You will earn",
      bonusInfoSuffix: "bonuses (5% of price)",
      fitting: "Fitting",
      askWhatsapp: "Ask via WhatsApp",
      notFound: "Product not found",
      goBack: "Back",
      loading: "Loading...",
    },
    news: {
      title: "News & Promotions",
      all: "All",
      promos: "Promotions",
      collections: "Collections",
      vip: "VIP",
      empty: "No news",
      read: "Read",
      hide: "Hide",
      promotion: "Promotion",
      collection: "Collection",
      newsItem: "News",
      vipExclusive: "VIP Exclusive",
    },
    appointment: {
      title: "Book a Fitting",
      subtitle: "Our manager will contact you to confirm",
      name: "Your name *",
      phone: "Phone number *",
      city: "Your city",
      date: "Preferred date (dd.mm.yy)",
      category: "Product category",
      comment: "Comment (optional)",
      submit: "Book a Fitting",
      submitting: "Sending...",
      success: "Request Received",
      thankYou: "Thank you! Angiolini manager will contact you shortly.",
      whatsapp: "Message on WhatsApp",
      home: "Go to Home",
      errorRequired: "Fill in required fields",
      errorSend: "Submission error",
    },
    profile: {
      bonuses: "Bonuses",
      purchasesLabel: "Purchases ₸",
      city: "CITY",
      bonusCard: "Bonus card & history",
      catalog: "Product catalog",
      news: "News & Promotions",
      appointment: "Book a Fitting",
      recent: "Recent Transactions",
      logout: "Log Out",
      language: "Language",
      pushOn: "Push notifications enabled",
      pushOff: "Enable push notifications",
      pushBusy: "Requesting permission...",
      pushBlocked: "Notifications blocked in browser",
      pushUnsupported: "Notifications not supported",
      pushTitle: "Receive notifications",
      pushHintOn: "New collections, promotions, VIP offers and boutique news",
      pushHintOff: "Turn on to hear about new collections and boutique events",
      pushHintBlocked: "Notifications are turned off in device settings",
      pushHintBridge: "The app could not connect to the notification system — open diagnostics below",
      pushHintUnsupported: "This device does not support push notifications",
      pushOpenSettings: "Open settings",
    },
    common: {
      loading: "Loading...",
      back: "Back",
      more: "Details",
      all: "All",
      notFound: "Not found",
      cancel: "Cancel",
      save: "Save",
    },
  },
};

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => {
    try { return localStorage.getItem("angiolini_lang") || "ru"; } catch { return "ru"; }
  });

  const changeLang = (l) => {
    setLang(l);
    try { localStorage.setItem("angiolini_lang", l); } catch {}
  };

  const t = T[lang] || T.ru;

  /**
   * Pick the localized version of a content field (e.g. product.name_kz).
   * Falls back to the base field (Russian) if a translation is missing.
   *
   * Usage:
   *   const { tField } = useLanguage();
   *   <h2>{tField(product, "name")}</h2>
   *   <p>{tField(product, "description")}</p>
   */
  const tField = (obj, fieldName) => {
    if (!obj || !fieldName) return "";
    if (lang === "ru") return obj[fieldName] || "";
    const translated = obj[`${fieldName}_${lang}`];
    return (translated && String(translated).trim()) || obj[fieldName] || "";
  };

  return (
    <LanguageContext.Provider value={{ lang, t, changeLang, T, tField }}>
      {children}
    </LanguageContext.Provider>
  );
}

export const useLanguage = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) {
    // Safe fallback so non-wrapped components do not crash
    return { lang: "ru", t: T.ru, changeLang: () => {}, T, tField: (o, f) => (o?.[f] || "") };
  }
  return ctx;
};
